module.exports = __webpack_public_path__ + "img/method.7af939c1.png";